export default __webpack_public_path__ + "static/media/Logo.e556672f.png";